module.exports = __webpack_public_path__ + "dbd9855ec793171a706e660eef829793.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/press_teaser_201608_sz.jpg
// module id = 648
// module chunks = 0